__turbopack_context__.v({
  "advisorCard": "styles-module__NH2TFW__advisorCard",
  "advisorCards": "styles-module__NH2TFW__advisorCards",
  "advisorInfo": "styles-module__NH2TFW__advisorInfo",
  "credentialsContainer": "styles-module__NH2TFW__credentialsContainer",
  "founderBioMobile": "styles-module__NH2TFW__founderBioMobile",
  "founderCard": "styles-module__NH2TFW__founderCard",
  "founderCardContainer": "styles-module__NH2TFW__founderCardContainer",
  "founderCardInfo": "styles-module__NH2TFW__founderCardInfo",
  "founderCardsContainer": "styles-module__NH2TFW__founderCardsContainer",
  "founderCredentials": "styles-module__NH2TFW__founderCredentials",
  "founderName": "styles-module__NH2TFW__founderName",
  "orangeGradientButton": "styles-module__NH2TFW__orangeGradientButton",
  "ourPartnersHeroBanner": "styles-module__NH2TFW__ourPartnersHeroBanner",
  "ourPartnersSectionContainer": "styles-module__NH2TFW__ourPartnersSectionContainer",
  "pageHeading": "styles-module__NH2TFW__pageHeading",
  "partnerRow": "styles-module__NH2TFW__partnerRow",
  "purpleGradientButton": "styles-module__NH2TFW__purpleGradientButton",
});
